import * as types from "./types";
import {
  getCustomerData,
  getCustomerDataBySerialNo,
} from "../../services/topup";
import {
  getActivePlans,
  getExpiredPlans,
  getInfo as getInfoService,
} from "../../services/profile";
import { getBalance as getBalanceService } from "../../services/register";

export default {
  setUser({ commit, dispatch }, data) {
    commit(types.SET_USER, data);
    dispatch("getUserInfo", data.accountNo);
  },

  async fetchCustomerData({ commit }, payload) {
    try {
      let data = await getCustomerData(payload);
      commit("setCustomerData", data.response.result);
    } catch (err) {
      //   throw err;
      console.log(err);
    }
  },
  async fetchCustomerDataBySerialNo({ commit}, payload) {
    try {
      let data = await getCustomerDataBySerialNo(payload);
      commit("setCustomerDataBySerialNo", data.response.result);
    } catch (err) {
      console.log("err", err);
      this.$toasted.error(err.message.error, {
        duration: 4000,
      });
    }
  },
  async getUserInfo({ commit, state, dispatch }) {
    try {
      const { accountNo } = state;
      const result = await getActivePlans(accountNo);
      const { response } = result;
      commit(types.SET_PROFILE, response);
      dispatch("getBalance");
      const infoResult = await getInfoService(accountNo);
      const {
        response: { result: userInfo },
      } = infoResult;
      commit(types.SET_USER_INFO, userInfo);
    } catch (err) {
      console.log(err);
    }
  },
  async getMonthlyCost({ commit }, payload) {
    try {
      const result = await getActivePlans(payload);
      //console.log("kfdjhgfdj", result);
      let { response } = result;
      if (response["active-plans"].length == 0) {
        const resultEx = await getExpiredPlans(payload);
        response = resultEx.response;
      }
      commit(types.SET_PROFILE, response);
    } catch (err) {
      console.log(err);
    }
  },

  async getBalance({ commit, state }) {
    try {
      const { accountNo } = state;
      const result = await getBalanceService(accountNo);
      const {
        response: { walletBalance },
      } = result;
      commit(types.SET_BALANCE, walletBalance);
    } catch (err) {
      console.log(err);
    }
  },
};
